import type { Account } from "@/api/types";

/**
 * The accounts a sale can be credited to (ADR-0046): income first, then liabilities that no role names,
 * which is where deferred revenue sits. A role names a control account, and a posting rule writes to
 * those, never a sales line. Nothing goes by an account's name, because a tenant can rename any of them.
 */
export function sellingAccounts(chart: readonly Account[] | undefined): Account[] {
  const active = (chart ?? []).filter((account) => account.isActive);
  return [
    ...active.filter((account) => account.group === "Income"),
    ...active.filter((account) => account.group === "Liabilities" && !account.hasRole),
  ];
}
